/**
 * 환생 전환 연출 타임라인 SSoT (순수, Phaser-free).
 *
 * 환생 버튼 → 게임 화면 페이드아웃 → 검은 화면 + 안내 텍스트 → (완전 암전 중) 리셋 → 페이드인.
 * 재생은 ui/RebirthTransitionOverlay가 담당하고, 여기는 "언제 무엇을"의 결정만 소유한다.
 *
 * 불변식 (rebirthTransitionTimeline.test.ts가 가드):
 *  - at 단조증가, done이 마지막 step.
 *  - reset은 fadeOut 완료 이후 ∧ fadeIn 시작 이전 — 리셋 순간이 반드시 암전에 가려진다.
 */
export type RebirthTransitionKind = "fadeOut" | "showText" | "reset" | "fadeIn" | "done";

export interface RebirthTransitionStep {
  /** 연출 시작 기준 경과 ms. */
  readonly at: number;
  readonly kind: RebirthTransitionKind;
  /** fadeOut/fadeIn/showText의 tween 길이 ms. */
  readonly durationMs?: number;
  /** showText의 i18n 키. */
  readonly textKey?: string;
}

export const REBIRTH_TRANSITION: readonly RebirthTransitionStep[] = [
  { at: 0, kind: "fadeOut", durationMs: 400 },
  { at: 400, kind: "showText", textKey: "rebirth.transition.doing", durationMs: 200 },
  { at: 700, kind: "reset" },
  { at: 1200, kind: "showText", textKey: "rebirth.transition.returning", durationMs: 200 },
  { at: 1900, kind: "fadeIn", durationMs: 500 },
  { at: 2400, kind: "done" },
];

/** 연출 총 길이 ms — done step의 at과 일치해야 한다 (테스트 가드). */
export const REBIRTH_TRANSITION_TOTAL_MS = 2400;
